import { usePagedListingApi } from '../shared/hooks/fetchingHooks';

const DATALAKE_API_ROUTE = '/api/datalake/logging';

const getLoggingDataApi = () => usePagedListingApi(DATALAKE_API_ROUTE);

export default getLoggingDataApi;
